export enum AccessabilityFontSize {
  small = 'small',
  normal = 'normal',
  large = 'large',
}
